import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=2a32f8ae&"
import script from "./TeacherEdit.vue?vue&type=script&lang=ts&"
export * from "./TeacherEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports